
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardFooter } from '@/components/ui/card';
import { Clock, TrendingUp } from 'lucide-react';

interface BlogPost {
  id: string;
  title: string;
  content: string;
  excerpt: string | null;
  featured_image: string | null;
  slug: string;
  author: string;
  published_date: string | null;
  status: 'draft' | 'published';
  seo_title: string | null;
  seo_description: string | null;
  seo_keywords: string[] | null;
  categories: string[] | null;
  tags: string[] | null;
  created_at: string | null;
  updated_at: string | null;
}

interface RelatedArticlesProps {
  posts: BlogPost[];
}

const RelatedArticles: React.FC<RelatedArticlesProps> = ({ posts }) => {
  return (
    <Card className="border-brand-trophy-gold/30 shadow-lg">
      <CardContent className="p-6">
        <h3 className="text-lg font-bold mb-4 text-brand-charcoal-gray flex items-center gap-2">
          <TrendingUp className="h-5 w-5 text-brand-trophy-gold" />
          Related Articles
        </h3>
        <div className="space-y-4">
          {posts.slice(0, 3).map(post => (
            <div key={post.id} className="flex items-start space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors">
              {post.featured_image && (
                <div className="h-16 w-16 rounded-lg overflow-hidden flex-shrink-0 border border-brand-trophy-gold/20">
                  <img
                    src={post.featured_image}
                    alt={post.title}
                    className="h-full w-full object-cover"
                  />
                </div>
              )}
              <div>
                <Link 
                  to={`/blog/${post.slug}`}
                  className="font-medium text-brand-charcoal-gray hover:text-brand-trophy-gold transition-colors line-clamp-2 text-sm"
                >
                  {post.title}
                </Link>
                <div className="text-xs text-gray-500 mt-1 flex items-center gap-1">
                  <Clock className="h-3 w-3" />
                  2 min read
                </div>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
      <CardFooter className="bg-gradient-to-br from-brand-safety-orange/5 to-brand-trophy-gold/5 p-6 border-t border-brand-trophy-gold/20">
        <div className="w-full">
          <h4 className="font-semibold mb-2 text-brand-charcoal-gray">Need roofing help?</h4>
          <p className="text-sm mb-4 text-gray-600">Contact our team for a free consultation and estimate</p>
          <Link to="/contact">
            <Button className="w-full bg-brand-safety-orange hover:bg-brand-safety-orange/90 text-white font-semibold shadow-lg">
              Contact Us
            </Button>
          </Link>
        </div>
      </CardFooter>
    </Card>
  );
};

export default RelatedArticles;
